import {
    SET_USER_INFO,
    SET_GIFT_LIST,
    SET_DRAW_GAME,
    SET_INSERT_ADDRESS,
    SET_SHOWING,
    SET_HISTORY,
    SET_TOTAL_HISTORY,
    SET_GAME,
    SET_HISTORY_LOCATE,
} from "@/stores/mutations";

export const mutations = {

    [SET_USER_INFO](state, data) {
        state.user = data;
    },

    [SET_GAME](state, data) {
        state.game = data;
    },

    [SET_GIFT_LIST](state, data) {
        state.gifts = data;
    },

    [SET_DRAW_GAME](state, data) {
        state.winGift = data;
    },

    [SET_INSERT_ADDRESS](state, data) {
        state.address = data;
    },

    [SET_HISTORY](state, data) {
        let page = data.page;
        let lang = data.lang;
        if (typeof state.historyByLangAndPage[lang] === 'undefined') {
            state.historyByLangAndPage[lang] = {}
        }
        state.historyByLangAndPage[lang][page] = data.data;
        let histories = [];
        for (let page in state.historyByLangAndPage[lang]) {
            histories = histories.concat(state.historyByLangAndPage[lang][page]);
        }
        state.histories = histories;
    },

    [SET_HISTORY_LOCATE](state, lang) {
        let histories = [];
        for (let page in state.historyByLangAndPage[lang]) {
            histories = histories.concat(state.historyByLangAndPage[lang][page]);
        }
        state.histories = histories;
    },

    [SET_TOTAL_HISTORY](state, data) {
        state.totalHistory = data;
    },

    [SET_SHOWING](state, data) {
        state.isShowing = data;
    },
}
